import React, { Component } from 'react';
import FontAwesomeIcon from '@fortawesome/react-fontawesome';
import ReactGA from 'react-ga'
import { base, app } from '../base'
import { isEmpty } from '@firebase/util';


const formStyles = {
  float: "left",
  width: "55%",
  margin: "20px auto",
  border: "1px solid #ddd",
  borderRadius: "5px",
  padding: "10px"
};

const userDataStyles = {
  float: "right",
  width: "40%",
  margin: "20px auto",
  border: "1px solid #ddd",
  borderRadius: "5px",
  padding: "10px"
};


class User extends Component {
  constructor(props) {
    super(props)
    this.updateField = this.updateField.bind(this)
    this.postToFireBase = this.postToFireBase.bind(this)
    this.handleCheckbox = this.handleCheckbox.bind(this)
    this.setEmailValueforDatabase = this.setEmailValueforDatabase.bind(this)
    this.state = {
      user: app.auth().currentUser,
      email: app.auth().currentUser.email,
      firstName: '',
      lastName: '',
      emailUpdates: 'N',
      emailBool: false,
    }
  }

  handleCheckbox(event) {
    let isChecked = event.target.checked
    this.setState({emailBool : isChecked })
    this.setEmailValueforDatabase(event)

  }

  setEmailValueforDatabase(event) {
    if(event.target.checked) {
      this.setState({emailUpdates: 'Y'})
    }
    else {
      this.setState({emailUpdates: 'N'})
    }
  }

  postToFireBase() {
    var immediatelyAvailableReference = base.post(`userData/${this.state.user.uid}/info`, {
      data: { firstName: this.state.firstName, lastName: this.state.lastName, emailUpdates: this.state.emailUpdates, email: this.state.user.email, owner: this.state.user.uid }
    }).then(newLocation => {
      var generatedKey = newLocation.key;
      this.setState({userInfo: { firstName: this.state.firstName, lastName: this.state.lastName, emailUpdates: this.state.emailUpdates, email: this.state.user.email, owner: this.state.user.uid }})
    }).catch(err => {
      //handle error
    });
    //available immediately, you don't have to wait for the Promise to resolve
    var generatedKey = immediatelyAvailableReference.key;


  }

  updateField(field, value) {
    this.setState({ [field]: value })
}




  componentDidMount() {
    ReactGA.pageview(window.location.pathname + window.location.search);
    base.fetch(`userData/${this.state.user.uid}/info`, {
      context: this,
      asObject: true
    }).then(data => {
      if (isEmpty(data)) {
        var immediatelyAvailableReference = base.post(`userData/${this.state.user.uid}/info`, {
          data: { firstName: this.state.firstName, lastName: this.state.lastName, emailUpdates: 'N', email: this.state.user.email, owner: this.state.user.uid }
        }).then(newLocation => {
          var generatedKey = newLocation.key;
        }).catch(err => {
          //handle error
        });

        //available immediately, you don't have to wait for the Promise to resolve
        var generatedKey = immediatelyAvailableReference.key;
      }
      else {
        this.setState({ firstName: data.firstName, lastName: data.lastName, emailUpdates: data.emailUpdates })
        if (data.emailUpdates === 'Y'){
          this.setState({emailBool: true})
    
        }
        else {
          this.setState({emailBool: false})
        }
      }
    }).catch(error => {
      console.log("Error Occured getting User Data -- " + error)
    })



  }
  componentWillUnmount() {
  }


  render() {
    var userData = this.state.userInfo;
    return (

      <div>
        Welcome
      <hr />
        <div style={{ width: "100%" }}>
          <div style={formStyles}>
            <form>
              <label className="pt-label">
                First Name
            <input style={{ width: "60%" }} className="pt-input" name="firstName" type="text" placeholder="First Name"
            onChange={(event) => this.updateField('firstName', event.target.value)}></input>
              </label>
              <label className="pt-label">
                First Name
            <input style={{ width: "60%" }} className="pt-input" name="comment" type="text" placeholder="Last Name"
            onChange={(event) => this.updateField('lastName', event.target.value)}></input>
              </label>
              <br />
              <label className="pt-control pt-checkbox .modifier">
                <input type="checkbox" 
                checked={this.state.emailBool}
                onChange={this.handleCheckbox}
                />
                <span className="pt-control-indicator"></span>
                Email Updates
                  </label>
              <br />
              <input style={{ width: "20%" }} type="submit" className="pt-button pt-intent-primary" value="Update Info"
                          onClick={this.postToFireBase}
              ></input>


            </form>
          </div>

          <div style={userDataStyles}>
            <h3>{this.state.email} </h3>
            <label className="pt-label">First Name: {this.state.firstName} </label>
            <label className="pt-label">Last Name: {this.state.lastName} </label>
            <label className="pt-label">Email Updates: {this.state.emailUpdates}</label>
          </div>
        </div>
        <div style={{ clear: 'both' }} />
      </div>
    )
  }
}

export default User


// WEBPACK FOOTER //
// ./src/components/User.jsx